import { useContext } from 'react'

import { MultiSelect } from '@mantine/core'

import { RecruitersContext } from 'src/context/RecruitersContext'

import { inlineSelectProps } from './inlineSelectStyles'

const MemberEmployeeOptions = ({ action, setSelected }) => {
  const recruiters = useContext(RecruitersContext) ?? []

  return (
    <div className="flex flex-col gap-3 text-xs">
      {recruiters.length === 0 ? (
        <div className="text-xs text-doubleNickel-gray-500">
          No recruiters found.
        </div>
      ) : (
        <MultiSelect
          {...inlineSelectProps}
          value={action?.memberEmployeeIds ?? []}
          onChange={(value) => setSelected({ memberEmployeeIds: value })}
          data={recruiters}
          className="max-w-sm"
          searchable
        />
      )}
    </div>
  )
}

export default MemberEmployeeOptions
